
import React from 'react';

let _textWidthCanvas;

export function textWidth(text, font) {
    if (!_textWidthCanvas) {
        _textWidthCanvas = document.createElement("canvas");
    }
    var context = _textWidthCanvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
}

export function childNodes(node, nodes)
{
    let ret = [];
    for (let i = 0; i < node.children.length; i++) {
        let childNode = nodes[node.children[i]];
        if ((childNode !== undefined) && (ret.indexOf(childNode) < 0)) {
            ret.push(childNode);
        }
    }
    if (node.fillerNodes) {
        for (let i = 0; i < node.fillerNodes.length; i++) {
            let fillerNode = node.fillerNodes[i];
            if ((fillerNode !== undefined) && (ret.indexOf(fillerNode) < 0)) {
                ret.push(fillerNode);
            }
        }
    }
    return ret;
}

/**
 *  Collect all descendants of a node that are drawn
 * @param {*} node  The node to collect descendants from
 * @param {*} retArray  The array to collect the descendants in
 * @returns The retArray
 */
export function drawnDescendants(node, retArray) {
    if (!node.drawChildNodes || node.drawChildNodes.length <= 0) {
        return retArray;
    }
    for (let i = 0; i < node.drawChildNodes.length; i++) {
        const childNode = node.drawChildNodes[i];
        drawnDescendants(childNode, retArray);
        retArray.push(childNode);
    }
    return retArray;
}


export function descendants(parentNode, nodes) {
    let ret = [];
    if (!parentNode) {
        return ret;
    }
    for (let i = 0; i < parentNode.children.length; i++) {
        let nodeId = parentNode.children[i];
        let subNodes = descendants(nodes[nodeId], nodes);
        ret.push(nodeId, ...subNodes);
    }
    return ret;
}

export function descendantNodes(parentNode) {
    let ret = [];
    if (!parentNode) {
        return ret;
    }
    for (let i = 0; i < parentNode.childNodes.length; i++) {
        let node = parentNode.childNodes[i];
        let subNodes = descendantNodes(node);
        ret.push(node, ...subNodes);
    }
    return ret;
}

export function findParent(node, actualLevel) {
    while (node.parentNode) {
        if (node.parentNode.actualLevel == actualLevel) {
            return node.parentNode;
        }
        node = node.parentNode;
    }
    return undefined;
}

export function findRoot(node) {
    let ret = node;
    // console.log("find", ret.parentNode.childNodes);
    while (ret && ret.parentNode && ret.parentNode.actualLevel > 0) {
        ret = ret.parentNode;
    }
    return ret;
}

export function childrenWidth(childNodes, childLayer) {
    if (!childLayer) {
        return 0;
    }
    let ret = childNodes.length * (childLayer.radius * 2 + childLayer.padding);
    //for (let i = 0; i < childNodes.length; i++) {
        //let node = childNodes[i];
        // ret += childLayer.radius * 1 + childLayer.padding;
    //}
    return ret > 0 ? ret + childLayer.padding * 1 : 0;
}

//console.log(getTextWidth("hello there!", "bold 12pt arial"));  // close to 86

export function minRadius(circumference) {
    // r = c / (2*pi)
    return circumference / (2 * Math.PI);
}

export function circumference(radius, angle = 360) {
    // c = r^2*pi
    return 2 * Math.PI * radius * angle / 360;
}

export function nodeHasName(node, lang)
{
    return node.names[lang] !== undefined;
}

export function nodeName(node, lang, altLang) {
    if (typeof node.names[lang] === 'string') {
        return node.names[lang].replace(/\|/g, '\u00AD');
    } else {
        for (let i = 0; i < altLang.length; i++) {
            let l = altLang[i];
            if (node.names[l] !== undefined) {
                return node.names[l].replace(/\|/g, '\u00AD') + "*";
            }
        }
    }
    return node.id;
}

export function nodeDescription(node, lang, altLang) {
    if (typeof node.descriptions[lang] === 'string') {
        return node.descriptions[lang].replace(/\|/g, '\u00AD');  //formatDescription(node.descriptions[lang]);
    } else if (altLang !== undefined) {
        for (let i = 0; i < altLang.length; i++) {
            let l = altLang[i];
            if (typeof node.descriptions[l] === 'string') {
                return node.descriptions[l].replace(/\|/g, '\u00AD'); //formatDescription(node.descriptions[l]) + "*";
            }
        }
    }
    return undefined;
}

export function nodeNames(node) {
    let languages = Object.keys(node.names).sort();
    let names = [];
    for (let i = 0; i < languages.length; i++) {
      let lang = languages[i];
      names.push({lang, name: node.names[lang]});
      if (node.altNames[lang]) {
        for (let ai = 0; ai < node.altNames[lang].length; ai++) {
          names.push({lang, name: node.altNames[lang][ai]});
        }
      }
    }
    return names;
}

export function nodeLangNames(node, lang) {
    let names = [];
    if (node.names[lang]) {
      names.push(node.names[lang]);
      if (node.altNames[lang]) {
        for (let ai = 0; ai < node.altNames[lang].length; ai++) {
          names.push(node.altNames[lang][ai]);
        }
      }
    }
    return names;
}

let _flags = [
    "ad","ae","af","ag","ai","al","am","ao","aq","ar","as","at","au","aw","ax","az","ba","bb","bd","be","bf",
    "bg","bh","bi","bj","bl","bm","bn","bo","bq","br","bs","bt","bv","bw","by","bz","ca","cc","cd","cf","cg",
    "ch","ci","ck","cl","cm","cn","co","cr","cu","cv","cw","cx","cy","cz","de","dj","dk","dm","do","dz","ec",
    "ee","eg","eh","er","es","et","eu","fi","fj","fk","fm","fo","fr","ga","gb-eng","gb-nir",
    "gb-sct","gb-wls","gb","gd","ge","gf","gg","gh","gi","gl","gm","gn","gp","gq","gr","gs","gt","gu","gw",
    "gy","hk","hm","hn","hr","ht","hu","id","ie","il","im","in","io","iq","ir","is","it","je","jm","jo","jp",
    "ke","kg","kh","ki","km","kn","kp","kr","kw","ky","kz","la","lb","lc","li","lk","lr","ls","lt","lu","lv",
    "ly","ma","mc","md","me","mf","mg","mh","mk","ml","mm","mn","mo","mp","mq","mr","ms","mt","mu","mv","mw",
    "mx","my","mz","na","nc","ne","nf","ng","ni","nl","no","np","nr","nu","nz","om","pa","pe","pf","pg","ph",
    "pk","pl","pm","pn","pr","ps","pt","pw","py","qa","re","ro","rs","ru","rw","sa","sb","sc","sd","se","sg",
    "sh","si","sj","sk","sl","sm","sn","so","sr","ss","st","sv","sx","sy","sz","tc","td","tf","tg","th","tj",
    "tk","tl","tm","tn","to","tr","tt","tv","tw","tz","ua","ug","um","un","us","uy","uz","va","vc","ve","vg",
    "vi","vn","vu","wf","ws","ye","yt","za","zm","zw"];

export function availableFlags() {
    return _flags;
}

export function rad(degrees) {
    return degrees * Math.PI / 180;
}

function deg(radians) {
    return radians * 180 / Math.PI;
}

export function circlePoint(center_x, center_y, angle, radius) {
    let angleRad = rad(angle);
    let x = center_x + radius * Math.cos(angleRad);
    let y = center_y + radius * Math.sin(angleRad);
    return {x,y};
}

export function outset(angle, amount) {
    let angleRad = rad(angle);
    let x = amount * Math.cos(angleRad);
    let y = amount * Math.sin(angleRad);
    return {x, y};
}

export function circleDistanceAngle(radius, distance) {
    return (distance / circumference(radius) * 360);
}

export function angle(x1, y1, x2, y2) {
    return norm(deg(Math.atan2(y2 - y1, x2 - x1)));
}

export function graphDepthFirst({rootNode, nodeCallback, mergeCallback = () => undefined}) {
    let data = undefined;
    if (rootNode.childNodes !== undefined) {
        for (let i = 0; i < rootNode.childNodes.length; i++) {
            data = mergeCallback(data, graphDepthFirst({ rootNode: rootNode.childNodes[i], nodeCallback, mergeCallback}));
        }
    } else {
        console.log("sdfsdf");
    }
    return nodeCallback(rootNode, data);
}

export function graphDrawnDepthFirst({rootNode, nodeCallback, mergeCallback = () => undefined}) {
    let data = undefined;
    if (rootNode.drawChildNodes !== undefined) {
        for (let i = 0; i < rootNode.drawChildNodes.length; i++) {
            data = mergeCallback(data, graphDrawnDepthFirst({ rootNode: rootNode.drawChildNodes[i], nodeCallback, mergeCallback}));
        }
    } else {
        console.log("sdfsdf");
    }
    return nodeCallback(rootNode, data);
}

export function norm(angle) {
    while (angle < 0) angle += 360;
    while (angle > 360) angle -= 360;
    return angle;
}

export function applyChangeset(graph, changeset, settings) {
    for (let index = 0; index < changeset.length; index++) {
        let change = changeset[index];
        if (change.type === 'add') {
            let parentNode = graph.nodes[change.parent];
            let nodeId = change.id;
            if (!nodeId) {
                console.warn('applyChangeset: skipping add change with no id', change);
                continue;
            }
            let lang = change.language;
            if (parentNode) {
                parentNode.edited = true;
                let node = {
                    id: nodeId,
                    names: {},
                    altNames: {},
                    parent: parentNode.id,
                    level: Math.min(change.level, settings.levels.length - 1),
                    locked: false,
                    children: [],
                    descriptions: [],
                    edited: true,
                };
                parentNode.children.push(nodeId);
                graph.nodes[nodeId] = node;

                node.names[lang] = change.names[0];
                node.altNames[lang] = [];
                for (let i = 1; i < change.names.length; i++) {
                    node.altNames[lang].push(change.names[i]);
                }
            }
        } else if (change.type === 'delete') {
            if (graph.nodes[change.id]) {
                let deletedNode = graph.nodes[change.id];
                let parentId = deletedNode.parent;
                if (parentId) {
                    let parentNode = graph.nodes[parentId];
                    // Reparent all children of the deleted node to the deleted node's parent
                    for (let i = deletedNode.children.length - 1; i >= 0; i--) {
                        let childId = deletedNode.children[i];
                        let child = graph.nodes[childId];
                        if (child) {
                            child.parent = parentId;
                            if (parentNode && !parentNode.children.includes(childId)) {
                                parentNode.children.push(childId);
                            }
                        }
                    }
                    deletedNode.children = [];
                    // Remove deleted node from parent's children
                    if (parentNode) {
                        let idx = parentNode.children.indexOf(change.id + '');
                        if (idx >= 0) {
                            parentNode.children.splice(idx, 1);
                        }
                        parentNode.edited = true;
                    }
                }
            }
            graph.nodes[change.id].edited = true;
            graph.nodes[change.id].deleted = true;
        } else if (change.type === 'name') {
            let node = graph.nodes[change.id];
            let lang = change.language;
            if (node) {
                node.edited = true;
                if (change.names.length > 0) {
                    node.names[lang] = change.names[0];
                    node.altNames[lang] = [];
                    for (let i = 1; i < change.names.length; i++) {
                        node.altNames[lang].push(change.names[i]);
                    }
                } else {
                    delete node.names[lang];
                    delete node.altNames[lang];
                }
            } else {
                console.log("changeset: Node not found " + change.nodeId);
            }
        } else if (change.type === 'description') {
            let node = graph.nodes[change.id];
            let lang = change.language;
            if (node) {
                node.edited = true;
                if (change.description !== undefined) {
                    node.descriptions[lang] = change.description;
                } else {
                    delete node.descriptions[lang];
                }
            }
        } else if (change.type === 'move') {
            let moveNode = graph.nodes[change.id];
            if (moveNode) {
                if (moveNode.parent !== change.parent) {
                    let newParent = graph.nodes[change.parent];
                    if (newParent) {
                        // Check if new parent is a descendant of the node
                        let parent = newParent;
                        let isNewParentDescendant = false;
                        while (parent) {
                            if (parent.id === moveNode.id) {
                                isNewParentDescendant = true;
                                break;
                            }
                            parent = graph.nodes[parent.parent];
                        }

                        if (isNewParentDescendant) {
                            // Move would create a loop, reparent node's children to node's parent
                            let parent = graph.nodes[moveNode.parent];
                            for (let i = moveNode.children.length - 1; i >= 0; i--) {
                                let child = graph.nodes[moveNode.children[i]];
                                if (child) {
                                    moveNode.children.splice(i, 1);
                                    child.parent = parent.id;
                                    parent.children.push(child.id);
                                    parent.edited = true;
                                }
                            }
                        }

                        // Continue with normal move
                        moveNode.edited = true;
                        let oldParent = graph.nodes[moveNode.parent];
                        if (oldParent) {
                            let index = oldParent.children.indexOf(moveNode.id);
                            if (index >= 0) {
                                oldParent.children.splice(index, 1);
                                oldParent.edited = true;
                            }
                        }
                        moveNode.parent = newParent.id;
                        newParent.children.push(moveNode.id);
                        
                    }
                }
                if (moveNode.level !== change.level) {
                    const oldLevel = moveNode.level;
                    moveNode.level = change.level;
                    moveNode.edited = true;
                    // Only adjust children when level is raised (increased).
                    // When lowering, children already have levels above the
                    // new parent level so they don't need any changes.
                    if (change.level > oldLevel) {
                        const maxLvl = settings.levels.length - 1;
                        const ensureChildLevels = (parentNode) => {
                            for (let i = 0; i < parentNode.children.length; i++) {
                                let child = graph.nodes[parentNode.children[i]];
                                if (child) {
                                    if (child.level <= parentNode.level) {
                                        child.level = Math.min(parentNode.level + 1, maxLvl);
                                        child.edited = true;
                                    }
                                    ensureChildLevels(child);
                                }
                            }
                        };
                        ensureChildLevels(moveNode);
                    }
                }
            }
        } else if (change.type === 'image') {
            //   {
            //     type: 'image',
            //     id: nodeId,
            //     imageData: imageData // { base64: "...", mimeType: "image/png", width: 350, height: 200 }
            // };
            let node = graph.nodes[change.id];
            if (node) {
                node.edited = true;
                node.imageId = 0;
                node.imageUrl = "data:" + change.imageData.mimeType + ";base64," + change.imageData.base64;
                node.imageData = change.imageData;
            }
        } else if (change.type === 'reorder') {
            let parentNode = graph.nodes[change.parentId];
            if (parentNode) {
                let nodeId = change.id + "";
                let idx = parentNode.children.indexOf(nodeId);
                if (idx >= 0) {
                    parentNode.children.splice(idx, 1);
                }
                if (change.afterSiblingId !== null && change.afterSiblingId !== undefined) {
                    let afterId = change.afterSiblingId + "";
                    let afterIdx = parentNode.children.indexOf(afterId);
                    if (afterIdx >= 0) {
                        parentNode.children.splice(afterIdx + 1, 0, nodeId);
                    } else {
                        parentNode.children.unshift(nodeId);
                    }
                } else {
                    // null afterSiblingId = place at beginning
                    parentNode.children.unshift(nodeId);
                }
                parentNode.edited = true;
            }
        }
            
    }
    return graph;
}


export function prepareGraphData(data, inSettings, language, changeset, rootNodeId) {
    if (!data || !data.nodes || !inSettings || !inSettings.levels) {
        return { graph: {}, settings: {} };
    }

    // Make copies of data and settings so we don't modify the originals
    let graph = JSON.parse(JSON.stringify(data));
    let settings = JSON.parse(JSON.stringify(inSettings));

    if (settings.actualLevels) {
        settings.levels = settings.actualLevels;
        settings.actualLevels = undefined;
    }

    settings.language = language || "gb";

    if (changeset) {
        graph = applyChangeset(graph, changeset, settings);
    }

    graph.root = rootNodeId;

    let rootNode = graph.nodes[rootNodeId];
    let rootLevel = rootNode.level;
    let ancestors = {};
    let usedLanguages = {};

    // Get ancestor nodes
    let node = graph.nodes[rootNode.parent];
    while (node) {
        ancestors[node.id] = node;
        node = graph.nodes[node.parent];
    }

    // Reparent nodes that refer to ancestor nodes, new parent should be rootNode
    for (let nodeId in graph.nodes) {
        if (graph.nodes.hasOwnProperty(nodeId)) {
            node = graph.nodes[nodeId];
            if ((node.level > rootLevel) && (ancestors[node.parent])) {
                if (!rootNode.children.includes(nodeId)) {
                    rootNode.children.push(nodeId);
                    node.actualParent = node.parent;
                    node.parent = rootNode.id;
                }
            }
            for (let lang in node.names) {
                if (node.names.hasOwnProperty(lang)) {
                    usedLanguages[lang] = true;
                }
            }
            
        }
    }

    let languages = [];
    for (let i = 0; i < settings.standardLanguages.length; i++) {
        usedLanguages[settings.standardLanguages[i]] = true;
    }
    for (let lang in usedLanguages) {
        if (usedLanguages.hasOwnProperty(lang) && usedLanguages[lang] === true) {
            languages.push(lang);
        }
    }
    languages.sort();
    settings.languages = languages;

    settings.actualLevels = JSON.parse(JSON.stringify(settings.levels));

    // Set initial values for levels
    for (let i = 0; i < settings.levels.length; i++) {
        let level = settings.levels[i];
        level.childrenWidth = 0;
        level.levelRadius = 0;
        level.longestText = 0;
        let actualLevel = settings.levels[rootLevel + i];
        level.name = actualLevel !== undefined ? actualLevel.name : "";
    }

    // Figure out what nodes we are going to draw (all nodes that are decendants of rootNode)
    let drawNodes = descendants(rootNode, graph.nodes);
    drawNodes.push(rootNode.id);

    // for (let i = 0; i < drawNodes.length; i++) {
    //     let nodeId = drawNodes[i];
    //     node = graph.nodes[nodeId];
    //     if (node.parent) {
    //         let parentNode = graph.nodes[node.parent];
    //         while (node.level - parentNode.level > 1) {

    //         }
    //     }
    // }

    for (let i = 0; i < drawNodes.length; i++) {
        let nodeId = drawNodes[i];
        node = graph.nodes[nodeId];

        if (node.parent) {
            node.parentNode = graph.nodes[node.parent];
        }
        node.drawParentNode = node.parentNode;
        node.drawChildNodes = [];
        // Get translation of name
        node.name = nodeName(node, settings.language, settings.alternativeLanguages);
        node.hasName = nodeHasName(node, settings.language);
        node.description = nodeDescription(node, settings.language, settings.alternativeLanguages);
        node.isFillerNode = false;

        node.actualLevel = node.level;
        // Adjust level to make root level 0
        node.level -= rootLevel;

        // Build up child nodes hierarchy array
        node.childNodes = childNodes(node, graph.nodes);
        node.drawChildNodes = [];

        // Calculate width of all children
        // node.childrenWidth = childrenWidth(node.childNodes, settings.levels[node.level]);
        // let childLevel = settings.levels[node.level + 1];
        // if (childLevel) {
        //     childLevel.childrenWidth += node.childrenWidth;
        // }

        let myLevel = settings.levels[node.level + 1];
        if (myLevel) {
            let myNameTextWidth = textWidth(node.name, myLevel.textStyle.fontSize + " Arial");
            if (myLevel.longestText < myNameTextWidth) {
            myLevel.longestText = myNameTextWidth;
            }
        }

        // This node should be included for drawing
        node.included = true;
    }
    // drawnDescendants(node, retArray) {
    //     if (!node.drawChildNodes || node.drawChildNodes.length <= 0) {
    //         return retArray;
    //     }
    //     for (let i = 0; i < node.drawChildNodes
    // Look for nodes that skips levels and create filler nodes for the missing levels
    for (let i = 0; i < drawNodes.length; i++) {
        let nodeId = drawNodes[i];
        node = graph.nodes[nodeId];

        if (!node || !node.included) continue;

        if (node.drawParentNode) {
            let parentNode = node.drawParentNode;

            if (!parentNode.drawChildNodes) {
                parentNode.drawChildNodes = [];
            }

            if (node.level - parentNode.level <= 1) {
                parentNode.drawChildNodes.push(node);
                continue;
            }

            let fillerNode = null;
            if (parentNode.fillerNodes) {
                for (let j = 0; j < parentNode.fillerNodes.length; j++) {
                    if (parentNode.fillerNodes[j].fillsToLevel === node.level) {
                        fillerNode = parentNode.fillerNodes[j];
                        break;
                    }
                }
            }

            if (fillerNode) {
                // Get the fillerEndNode and set it as node's parent
                let fillerEndNode = fillerNode.fillerEndNode;
                if (fillerEndNode) {
                    // fillerEndNode.children.push(node.id);
                    // fillerEndNode.childrenWidth += node.childrenWidth; // TODO: Check if this is correct
                    if (node.hasName) {
                        fillerEndNode.hasName = true;
                    }
                    node.drawParentNode = fillerEndNode;
                    fillerEndNode.drawChildNodes.push(node);
                } else {
                    fillerNode = null;
                    console.log("fillerEndNode not found, should not happen");
                }
            }

            if (!fillerNode) {
                let lastFillerNode = null;
                let firstFillerNode = null;
                while (node.level - parentNode.level > 1) {
                    let fillerNode = {
                        id: "filler-" + node.id + "-" + parentNode.id,
                        parent: parentNode.id,
                        level: parentNode.level + 1,
                        names: {},
                        altNames: {},
                        children: [],
                        descriptions: [],
                        edited: true,
                        isFillerNode: true,
                        fillsToLevel: node.level,
                        included: true,
                        drawParentNode: parentNode,
                        drawChildNodes: [],
                    };
                    // parentNode.children.push(fillerNode.id);
                    // parentNode.childNodes.push(fillerNode);
                    parentNode.drawChildNodes.push(fillerNode);
                    graph.nodes[fillerNode.id] = fillerNode;
                    // drawNodes.push(fillerNode.id);

                    fillerNode.name = "";
                    fillerNode.hasName = node.hasName;
                    fillerNode.description = "";
                    fillerNode.actualLevel = fillerNode.level;
                    fillerNode.childNodes = [];
                    fillerNode.childrenWidth = 0;
                    fillerNode.actualParent = parentNode.id;
                    fillerNode.parentNode = parentNode;
                    fillerNode.included = true;
                    if (!parentNode.fillerNodes) {
                        parentNode.fillerNodes = [fillerNode];
                    } else {
                        parentNode.fillerNodes.push(fillerNode);
                    }
                    if (firstFillerNode === null) {
                        firstFillerNode = fillerNode;
                    }
                    parentNode = fillerNode;
                    lastFillerNode = fillerNode;
                }
                if (lastFillerNode) {
                    firstFillerNode.fillerEndNode = lastFillerNode;
                    node.drawParentNode = lastFillerNode;
                    lastFillerNode.drawChildNodes.push(node);
                    // // Remove node from parent's children
                    // let index = parentNode.children.indexOf(node.id);
                    // if (index >= 0) {
                    //     parentNode.children.splice(index, 1);
                    // }
                }
            }
        }
    }

    // drawNodes = descendants(rootNode, graph.nodes);
    // drawNodes.push(rootNode.id);
    drawNodes = drawnDescendants(rootNode, []);
    drawNodes.push(rootNode);

    // Recalculate childrenWidth for all nodes
    for (let i = 0; i < drawNodes.length; i++) {
        // let nodeId = drawNodes[i];
        node = drawNodes[i];

        if (!node || !node.included) continue;

        let level = settings.levels[node.level];
        let childLevel = settings.levels[node.level + 1];
        node.childrenWidth = childrenWidth(node.drawChildNodes, childLevel);

        if (childLevel && node.childrenWidth > 0) {
            childLevel.childrenWidth += node.childrenWidth + childLevel.padding;
            childLevel.parentCount = (childLevel.parentCount || 0) + 1;
        }
    }

    // Set up root node properties
    rootNode.minAngle = 350;  
    rootNode.x = 0;
    rootNode.y = 0;
    rootNode.childNodes = childNodes(rootNode, graph.nodes);
    rootNode.drawChildNodes = childNodes(rootNode, graph.nodes);

    // Calculate initial level radiuses
    let lastRadius = -10;//-20;//settings.levels[0].radius + -40;
    let lastUsedRadius = 0;
    for (let i = 1; i < settings.levels.length; i++) {
        let level = settings.levels[i];
        let prevLevel = settings.levels[i - 1];
        level.containsNodes = (level.childrenWidth !== 0);
        // Account for both previous and current node radii, allowing 10% overlap
        let nodeSpacing = (prevLevel.radius + level.radius) * 0.9;
        level.levelRadius = lastRadius + nodeSpacing + minRadius(level.childrenWidth);
        let nextLevel = settings.levels[i + 1];
        if (nextLevel && level.textLocation !== "inside") {
            let textLevelRadius = lastRadius + nextLevel.longestText + level.radius + nextLevel.radius + 40;
            if (level.levelRadius < textLevelRadius) {
                level.levelRadius = textLevelRadius;
            }
        }
        // Minimum gap based on node sizes so adjacent rings don't overlap
        let minGap = nodeSpacing + level.padding;
        // Only enforce global minLevelRadiusDifference when it's actually needed
        // to prevent overlap of sizable nodes; for small nodes let the
        // node-size-based spacing and childrenWidth drive the ring distance
        if (minGap < settings.minLevelRadiusDifference && nodeSpacing > settings.minLevelRadiusDifference * 0.3) {
            minGap = settings.minLevelRadiusDifference;
        }
        if (level.levelRadius < lastRadius + minGap) {
            level.levelRadius = lastRadius + minGap;
        }
        lastRadius = level.levelRadius;
        if (level.childrenWidth > 0) {
            lastUsedRadius = lastRadius;
        }
        //settings.levels[i] = level;
    }

    // Smoothing pass: nudge layer radii so gaps are more even.
    // Collect the used levels (those with nodes) and blend their gaps
    // ~30% toward the average, without shrinking below the original.
    let usedLevels = [];
    for (let i = 1; i < settings.levels.length; i++) {
        if (settings.levels[i].containsNodes) {
            usedLevels.push(i);
        }
    }
    if (usedLevels.length >= 2) {
        let gaps = [];
        for (let j = 0; j < usedLevels.length; j++) {
            let prev = j === 0 ? 0 : settings.levels[usedLevels[j - 1]].levelRadius;
            gaps.push(settings.levels[usedLevels[j]].levelRadius - prev);
        }
        // Exclude the first gap (root→first layer) from average calculation
        let outerGaps = gaps.slice(1);
        let avgGap = outerGaps.length > 0 ? outerGaps.reduce((a, b) => a + b, 0) / outerGaps.length : gaps[0];
        let smoothFactor = 0.5;

        // Blend each gap toward the average and recompute radii outward
        // Skip the first gap (j=0) to keep the first layer tight against the root
        let currentRadius = gaps[0];
        settings.levels[usedLevels[0]].levelRadius = currentRadius;
        for (let j = 1; j < usedLevels.length; j++) {
            let smoothedGap = gaps[j] + (avgGap - gaps[j]) * smoothFactor;
            // Never shrink below original gap (which already satisfies min overlap constraints)
            smoothedGap = Math.max(smoothedGap, gaps[j]);
            currentRadius += smoothedGap;
            settings.levels[usedLevels[j]].levelRadius = currentRadius;
        }
        // Also update non-used levels that sit between used ones (interpolate)
        for (let i = 1; i < settings.levels.length; i++) {
            if (settings.levels[i].containsNodes) continue;
            // Find nearest used levels before and after
            let prevUsed = 0, prevRadius = 0;
            let nextUsed = null, nextRadius = null;
            for (let j = i - 1; j >= 1; j--) {
                if (settings.levels[j].containsNodes) { prevUsed = j; prevRadius = settings.levels[j].levelRadius; break; }
            }
            for (let j = i + 1; j < settings.levels.length; j++) {
                if (settings.levels[j].containsNodes) { nextUsed = j; nextRadius = settings.levels[j].levelRadius; break; }
            }
            if (nextUsed !== null) {
                let t = (i - prevUsed) / (nextUsed - prevUsed);
                settings.levels[i].levelRadius = prevRadius + t * (nextRadius - prevRadius);
            }
        }
        lastUsedRadius = settings.levels[usedLevels[usedLevels.length - 1]].levelRadius;
    }

    // Calculate node minimum angles
    graphDrawnDepthFirst({
        rootNode, 
        nodeCallback: (node, childrenAngle) => {
            let level = settings.levels[node.level];
            let myAngle = circleDistanceAngle(level.levelRadius, level.radius * 2 + level.padding);
            let ret = myAngle;
            if (childrenAngle !== undefined) {
                ret = childrenAngle > myAngle ? childrenAngle : myAngle;
            }
            node.minAngle = ret;
            return ret;
        },
        mergeCallback: (accAngle,nodeAngle) => {
            accAngle = accAngle || 0;
            return accAngle + nodeAngle;
        }
    });

    graph.drawNodes = drawNodes.map(node => node.id);

    // TODO: Adjust radius to fit all nodes

    settings.graphSize = lastUsedRadius * 2 + 200;

    calcNodePositions(rootNode, graph, settings, 350);

    return { graph, settings };
}

export function calcNodePositions(parentNode, graph, settings, givenAngle) {
    if (parentNode.drawChildNodes === undefined) {
        return;
    }

    givenAngle = givenAngle || parentNode.minAngle;

    let angleToCenter = 0;
    if (parentNode.x !== 0 || parentNode.y !== 0) {
        angleToCenter = norm(angle(0, 0, parentNode.x, parentNode.y));
    }

    let totalAngle = parentNode.drawChildNodes.reduce((a, b) => a + b.minAngle, 0);
    let angleFactor = totalAngle > 0 ? givenAngle / totalAngle : 1;
    if ( angleFactor > 2) {
        angleFactor = 2;
        // totalAngle = angleFactor * totalAngle;
    }

    let nextStartAngle = norm(angleToCenter - totalAngle * angleFactor / 2); //angleToCenter - circleDistanceAngle(childLevel.levelRadius, parentNode.childrenWidth / 2)
    for (let i = 0; i < parentNode.drawChildNodes.length; i++) {
        let node = parentNode.drawChildNodes[i];
        let myAngleWidth = node.minAngle * angleFactor;
        let myAngle = norm(nextStartAngle + myAngleWidth / 2);

        // Store the angular arc this node owns (for cone detection during drag)
        node.arcStart = nextStartAngle;
        node.arcEnd = norm(nextStartAngle + myAngleWidth);
        node.arcWidth = myAngleWidth;

        let childLevel = settings.levels[node.level];
        if (!childLevel) {
            return;
        }

        let { x, y } = circlePoint(0, 0, myAngle, childLevel.levelRadius);
        node.x = x;
        node.y = y;

        calcNodePositions(node, graph, settings, myAngleWidth);
        nextStartAngle = norm(nextStartAngle + myAngleWidth);
    }
}

// module.exports = {
//     textWidth,
//     childNodes,
//     childrenWidth,
//     descendants,
//     descendantNodes,
//     minRadius,
//     circumference,
//     nodeHasName,
//     nodeName,
//     nodeDescription,
//     nodeNames,
//     nodeLangNames,
//     availableFlags,
//     circlePoint,
//     outset,
//     circleDistanceAngle,
//     angle,
//     norm,
//     deg,
//     rad,
//     graphDepthFirst,
//     prepareGraphData,
//     calcNodePositions,
//     findParent,
//     findRoot,
// }

export default {
    textWidth,
    childNodes,
    childrenWidth,
    descendants,
    descendantNodes,
    minRadius,
    circumference,
    nodeHasName,
    nodeName,
    nodeDescription,
    nodeNames,
    nodeLangNames,
    availableFlags,
    circlePoint,
    outset,
    circleDistanceAngle,
    angle,
    norm,
    deg,
    rad,
    graphDepthFirst,
    prepareGraphData,
    calcNodePositions,
    findParent,
    findRoot,
}
